
const API_URL = process.env.API_HOST + '/api/produk/'

export const ProductService = {
  list,
  add,
  edit,
  hapus
}

async function list () {
  return fetch(API_URL, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

async function hapus (newsid) {
  return fetch(API_URL + newsid, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

async function add (postdata) {
  var data = JSON.stringify({ postdata })
  return fetch(API_URL, {
    method: 'POST',
    body: JSON.stringify(JSON.parse(data).postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

async function edit (postdata) {
  return fetch(API_URL, {
    method: 'POST',
    body: JSON.stringify({ postdata }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)

    if (!data.success) {
      if (response.status === 401) {
        console.log("CALL LOGOUT");
        localStorage.setItem('token',null);
        localStorage.clear();
        location.reload(true)
      }
      const error = (data && data.msg) || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}
